<template>
    <div id="form-inbox">
        <div class="header">
            <div class="header-item" @click="$router.go(-1)">
                <md-icon class="icon">arrow_back</md-icon>
                <span class="header-text">Geri</span>
            </div>
            <div class="header-item" @click="filterNotRead">
                <md-icon class="icon">inbox</md-icon>
                <span class="header-text">Gelen Kutusu ({{ answerTotal.notRead }})</span>
            </div>
            <div class="header-item" @click="filterRead">
                <md-icon class="icon">send</md-icon>
                <span class="header-text">Okundu ({{ answerTotal.read }})</span>
            </div>
            <div class="header-item" style="opacity: 0.5">
                <md-icon class="icon">archive</md-icon>
                <span class="header-text">Arşiv</span>
            </div>
        </div>
        <div class="container">
            <div class="inbox-menu">
                <InboxMenu
                    v-if="!loading"
                    :answersData="filteredAnswers"
                    @item-selected="formAnswers"
                />
                <div v-else class="spinner">Loading...</div>
            </div>
            <div class="inbox-content">
                <InboxContents
                    v-if="selectedAnswer"
                    :answersData="selectedAnswer"
                    :not-read-btn="notReadBtn"
                    @mark-as-read="updateData"
                />
                <div v-else>
                    Select an item to see details.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import InboxMenu from "./FormInbox/InboxMenu.vue";
import InboxContents from "./FormInbox/InboxContents.vue";

export default {
    name: "FormInbox",
    components: {
        InboxMenu,
        InboxContents,
    },
    data() {
        return {
            formId: this.$route.params.formId,
            answersData: [],
            selectedAnswer: null,
            loading: true,
            filterStatus: "notRead",
            notReadBtn: true,
            answerTotal: 0,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
        filteredAnswers() {
            return this.answersData.filter(answer => answer.submission.status === this.filterStatus);
        },
    },
    mounted() {
        this.getInboxForm();
        this.fetchAnswerTotal();
    },
    methods: {
        ...mapActions({
            getFormAnswers: "forms/getFormAnswers",
            getFormAnswerTotal: "forms/getFormAnswerTotal",
        }),
        async getInboxForm() {
            try {
                this.loading = true;
                this.answersData = await this.getFormAnswers({ siteId: this.site._id, formId: this.formId });
                if (this.answersData && this.answersData.length > 0) {
                    this.formAnswers(this.filteredAnswers[0].submission._id);
                } else {
                    this.selectedAnswer = null;
                }
            } catch (error) {
                console.error("Error fetching form answers:", error);
            } finally {
                this.loading = false;
            }
        },
        formAnswers(submissionId) {
            if (this.answersData && this.answersData.length > 0) {
                this.selectedAnswer = this.answersData.find(answer => answer.submission._id === submissionId);
            } else {
                this.selectedAnswer = null;
            }
        },
        filterNotRead() {
            this.filterStatus = "notRead";
            if (this.filteredAnswers.length > 0) {
                this.formAnswers(this.filteredAnswers[0].submission._id);
            } else {
                this.selectedAnswer = null;
            }
            this.notReadBtn = true;
        },
        filterRead() {
            this.filterStatus = "read";
            if (this.filteredAnswers.length > 0) {
                this.formAnswers(this.filteredAnswers[0].submission._id);
            } else {
                this.selectedAnswer = null;
            }
            this.notReadBtn = false;
        },
        async fetchAnswerTotal() {
            try {
                const total = await this.getFormAnswerTotal({
                    siteId: this.site._id,
                    formId: this.formId,
                    status: "notRead",
                });
                this.answerTotal = total;
            } catch (error) {
                console.error("Error fetching not read total:", error);
            }
        },
        updateData() {
            this.getInboxForm();
            this.fetchAnswerTotal();
        },
    }
};
</script>

<style lang="scss" scoped>
#form-inbox {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #e0f7fa;

    .header {
        display: flex;
        width: 100%;
        background-color: #0288d1;
        padding: 5px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        .header-item {
            display: flex;
            align-items: center;
            padding: 5px 10px;
            margin: 0 5px;
            background-color: #ffffff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            cursor: pointer;

            .icon {
                margin-right: 5px;
                font-size: 1.2rem;
                color: #0288d1;
            }

            .header-text {
                font-size: 1rem;
                color: #0288d1;
                font-weight: bold;
            }
        }
    }

    .container {
        display: flex;
        width: 100%;
        height: 94%;
        margin: 0px;
        padding: 0px;

        .inbox-menu {
            width: 25%;
            padding: 10px;
            border-right: 2px solid #e5e5f5;
        }

        .inbox-content {
            width: 75%;
            background-color: #ffffff;
            padding: 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
    }

    .spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: 1.5rem;
        color: #0288d1;
    }
}
</style>
